import { render, staticRenderFns } from "./Mylove.vue?vue&type=template&id=ffd3db10&scoped=true"
import script from "./Mylove.vue?vue&type=script&lang=js"
export * from "./Mylove.vue?vue&type=script&lang=js"
import style0 from "./Mylove.vue?vue&type=style&index=0&id=ffd3db10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd3db10",
  null
  
)

export default component.exports